// extracted by mini-css-extract-plugin
export default {"container":"pu-z","title":"qu-z","linkContainer":"ru-z","viewItemLink":"su-z"};